/**
 * @param  {Notice} notice the Notice
 * @param  {Function} method function to invoke on Notice
 * @param  {Any} args arguments binded to function call
 * @return {void}
 */
export function noticeManager(notice, method, args) {
  if (args === undefined) {
    notice[method]();
  } else if (args.length > 1) {
    notice[method](...args);
  } else {
    notice[method](args[0]);
  }
}

/**
 * @class Notice
 * @export
 */
export class Notice {
  /**
   * Creates a new instance of a menu.
   * @param  {String} type e. g. error, success
   * @param  {String} message message
   * @param  {Number} x x coordinate
   * @param  {Number} y y coordinate
   * @return {void}
  */
  constructor(type, message, x, y) {
    const noticeTemplate = document.getElementById('notice');

    if (noticeTemplate !== null) {
      this.notice = noticeTemplate.cloneNode(true);
      const closeButton = this.notice.querySelector('[data-close]');

      // remove ID
      this.notice.id = undefined;

      // set type
      if (type !== undefined) this.setType(type);

      // set message
      if (type !== undefined) this.setMessage(message);

      // set position
      if (x !== undefined && y !== undefined) {
        this.setPosition(x, y);
      }

      // add event listener
      closeButton.addEventListener('click', () => {
        this.close(this.notice);
      });
    }
  }

  /**
   * @return {void}
   */
  handleTimeout() {
    if (!this.timeout) {
      // init
      this.timeout = window.setTimeout(() => {
        this.close();
      }, 4000);
    } else {
      // clear
      window.clearTimeout(this.timeout);

      // reinit
      this.timeout = window.setTimeout(() => {
        this.close();
      }, 4000);
    }
  }

  /**
   * @param  {String} type e. g. error, success
   * @return {void}
   */
  setType(type) {
    this.notice.dataset.type = type;

    this.handleTimeout();
  }

  /**
   * @param  {String} message message
   * @return {void}
   */
  setMessage(message) {
    const messageNode = this.notice.querySelector('[data-notification-message]');

    messageNode.innerHTML = message;

    this.handleTimeout();
  }

  /**
   * @param  {String} context Selector for placement of notice
   * @return {void}
   */
  render(context = 'body') {
    this.rendered = true;
    document.querySelector(context).appendChild(this.notice);

    this.handleTimeout();
  }

  /**
   * @return {void}
   */
  close() {
    if (this.rendered && this.notice !== null) {
      this.notice.parentNode.removeChild(this.notice);
    }

    this.rendered = false;
  }

  /**
   * @param  {Number} x x coordinate
   * @param  {Number} y y coordinate
   * @return {void}
   */
  setPosition(x, y) {
    this.notice.style.left = `${x}px`;
    this.notice.style.top = `${y}px`;

    this.handleTimeout();
  }

  /**
   * @param  {HTMLElement} element element to position notice
   * @param  {String} context Selector for placement of notice
   * @return {void}
   */
  displayNoticeAtElementPosition(element, context) {
    const elementDimensions = element.getBoundingClientRect();
    const contentWrapperDimensions = document.querySelector('.main-content').getBoundingClientRect();
    const arrow = this.notice.querySelector('[data-arrow-position]');
    const top = context ? document.querySelector(context).scrollTop : window.pageYOffset;
    const offset = 20;
    const arrowPosition = 32;
    const elementPositionLeftRelative = elementDimensions.left - contentWrapperDimensions.left;
    const noticeWidth = this.notice.getBoundingClientRect().width;
    const noticePositionLeft =
      (elementDimensions.left + (elementDimensions.width / 2))
      - arrowPosition;
    const noticePositionRight =
      (elementDimensions.left +
      (elementDimensions.width / 2) +
      arrowPosition) - noticeWidth;
    const noticePositionTop =
      (elementDimensions.top + top)
      - this.notice.getBoundingClientRect().height
      - offset;

    if (elementPositionLeftRelative < noticeWidth / 2) {
      // set notice position
      this.setPosition(noticePositionLeft, noticePositionTop);
      arrow.dataset.arrowPosition = 'left';
    } else if (contentWrapperDimensions.width - elementPositionLeftRelative < noticeWidth / 2) {
      // set notice position
      this.setPosition(noticePositionRight, noticePositionTop);
      arrow.dataset.arrowPosition = 'right';
    } else {
      this.setPosition(
        (elementDimensions.left + (elementDimensions.width / 2))
        - (noticeWidth / 2), noticePositionTop);
      arrow.dataset.arrowPosition = 'center';
    }

    this.handleTimeout();
  }
}



// WEBPACK FOOTER //
// ./assets/js/components/notice.js